import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import "./style.scss";
import TradingGrowthChart from "./TradingGrowthChart";
import { FormatUSD } from "../../../utils/helpers/string";
import { getBalanceChartRequest } from "../../../utils/apis/accountsApi";
import { useSelector } from "react-redux";
import Goals from "../Goals";
import CustomRangeSelector from "../../../reusableComponents/RangeSelector/CustomRangeSelector";

function TradingGrowth({ data, activeAccount, newMaxLoss, loginId }) {
  const { idToken } = useSelector((state) => state.auth);
  const { login_id } = useSelector((state) => state.accountList);

  // Initialize range state with today
  const [range, setRange] = useState([dayjs(), dayjs()]);

  // Params for API call
  const [params, setParams] = useState({
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  });

  const [balanceChart, setBalanceChart] = useState([]);

  const actualAccountName = data?.account_name || '';
  const planName = data?.account_metrics?.calculated_data?.plan_name || '';
  const isTestOrTournament = actualAccountName?.toLowerCase().startsWith('test') ||
    actualAccountName?.toLowerCase().startsWith('tournament');
  const showProfitTarget = !isTestOrTournament && planName?.toLowerCase() !== "direct plan";

  const fetchBalanceChartData = async () => {
    try {
      if (login_id !== null || loginId) {
        const response = await getBalanceChartRequest(
          idToken,
          login_id || loginId
          // params
        );
        setBalanceChart(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch data on loginId, token or params change (params are dates here)
  useEffect(() => {
    fetchBalanceChartData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login_id, idToken, params]);

  const handleRangeChange = (dates, dateStrings) => {
    if (dates && dates.length === 2) {
      setRange(dates);
      setParams({
        start_date: dateStrings[0],
        end_date: dateStrings[1],
      });
    } else {
      // Clear dates or reset to today if needed
      setRange([]);
      setParams({
        start_date: "",
        end_date: "",
      });
    }
  };

  // Legend data for display
  const legendData = [
    {
      title: "Balance",
      value: data?.account_balance_equity?.balance,
      color: "#05FF00",
    },
    ...(showProfitTarget ? [{
      title: "Profit Target",
      value:
        data?.account_metrics?.calculated_data?.starting_balance +
        data?.account_metrics?.program_objectives?.profit_target,
      color: "#FF0",
    }] : []),
    {
      title: "Maximum Loss Limit",
      value: data?.account_metrics?.program_objectives?.max_loss_target,
      color: "#F00",
    },
  ];

  return (
    <div className="trading-growth">
      <div className="trading-growth-left box">
        <div className="trading-growth-header">
          <h2 className="component-heading">Trading Growth Curve</h2>

          <div className="header-right">
            {/* <CustomRangeSelector
              dateRange={range}
              handleDateChange={handleRangeChange}
            />{" "} */}
          </div>
        </div>

        <div className="trading-growth-chart">
          <div className="chart-legend">
            {legendData.map((item, index) => (
              <div className="legend" key={index}>
                <div>
                  <span style={{ background: item.color }} className="circle" />
                  <p className="title">{item.title}:</p>
                </div>
                <p
                  className={
                    item?.value > 0 ? "positive_value" : "navative_value"
                  }
                >
                  {FormatUSD(item.value)}
                </p>
              </div>
            ))}
          </div>
          <TradingGrowthChart
            balance_chart={balanceChart}
            profit={
              showProfitTarget ? (
                data?.account_metrics?.calculated_data?.starting_balance +
                data?.account_metrics?.program_objectives?.profit_target
              ) : null
            }
            maxLoss={data?.account_metrics?.program_objectives?.max_loss_target}
            newMaxLoss={newMaxLoss}
          />
        </div>
      </div>

      <Goals data={data} newMaxLoss={newMaxLoss} />
    </div>
  );
}

export default TradingGrowth;
